import { render } from "./TabB.vue?vue&type=template&id=fba603f2&scoped=true"
import script from "./TabB.vue?vue&type=script&lang=js"
export * from "./TabB.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fba603f2"

export default script